import React from "react";
import { Button, Form, Input, message } from "antd";

import { forgotPasswordV2 } from "../actions";

import "../Login.scss";

const ForgotPassword3 = ({ handleChangeStep = () => {}, dataForm = {} }) => {
  const onFinish = async (values) => {
    try {
      const dataDto = {
        ...dataForm,
        ...values,
      };
      delete dataDto.rePassword;
      const { data } = await forgotPasswordV2(dataDto);
      if (data.code === 200) {
        handleChangeStep(4);
        message.success("Đăng ký tài khoản thành công");
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {}
  };

  const onFinishFailed = () => {};
  return (
    <>
      <Form
        colon={false}
        hideRequiredMark
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className="login-form"
      >
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập mật khẩu",
            },
          ]}
        >
          <Input
            type="password"
            placeholder="Mật khẩu"
            className="input-login"
          />
        </Form.Item>
        <Form.Item
          name="rePassword"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập lại mật khẩu",
            },
          ]}
        >
          <Input
            type="password"
            placeholder="Xác nhận lại mật khẩu"
            className="input-login"
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: "16px" }}>
          <Button type="primary" htmlType="submit" className="btn-login">
            Hoàn thành
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ForgotPassword3;
